import React, {Component} from "react";
import {
    ADD_INSTRUMENT_ROUTE,
    CONTROL_PANEL_EXTENSION_LOAN,
    CONTROL_PANEL_ROUTE
} from "../../../utils/constants/RoutesConstants";
import ExtensionLoan from "./ExtensionLoanView";
import {MoveGuaranteeService} from "../../../service/controlPanel/MoveGuaranteeService";
import {Growl} from "primereact/growl";
import ConfirmationMessage from "../../../components/confirmationMessage";
import {amountCalculate, validateNumberIntegersDecimals} from "../../../utils/formatters/Numbers";
import {getReward, withoutComma} from "../../../utils/calculate/Amount";
import {ControlPanelService} from "../../../service/controlPanel/ControlPanelService";

export default class ExtensionLoanContainer extends Component {
    constructor(props) {
        super(props);

        this.extensionConfirmationRef = null;
        this.setExtensionConfirmationRef = element => {
            this.extensionConfirmationRef = element
        };
        this.guaranteeConfirmationRef = null;
        this.setGuaranteeConfirmationRef = element => {
            this.guaranteeConfirmationRef = element
        };

        this.controlPanelService = new ControlPanelService();

        this.moveGuaranteeService = new MoveGuaranteeService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.updateGuaranteeTotal = this.updateGuaranteeTotal.bind(this);
        this.validateMarginCall = this.validateMarginCall.bind(this);
        this.validateExtensionPr = this.validateExtensionPr.bind(this);
        this.changeGuaranteeScreen = this.changeGuaranteeScreen.bind(this);
        this.extendLoan = this.extendLoan.bind(this);
        this.saveData = this.saveData.bind(this);
        this.showExtensionConfirmationMessage = this.showExtensionConfirmationMessage.bind(this);
        this.showGuaranteeConfirmationMessage = this.showGuaranteeConfirmationMessage.bind(this);
        this.redirectAddInstrument = this.redirectAddInstrument.bind(this);
        this.showGuarantees = this.showGuarantees.bind(this);
        this.updateGuaranteeGrids = this.updateGuaranteeGrids.bind(this);

        this.state = {
            isLoading: true,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanId: this.props.location.state.folio,
            status: this.props.location.state.status,
            loanAmount: this.props.location.state.loanAmount24Hrs,
            maturity: this.props.location.state.maturity,
            account: this.props.location.state.borrowerAccount,
            extensionType: 'N',
            extensionData: {
                plazo: '',
                tasa: '',
                sobretasa: '',
            },
            disableValues: false,
            guaranteeAmount: 0,
            isVisibleGuarantee: false,
            legendGuaranteesConfirmMsg: "¿Está seguro que desea prorrogar el préstamo?",
        };

        this.loanData = React.createRef();
        this.guaranteeForChange = React.createRef();
        this.guaranteeInAccount = React.createRef();

        if (this.props.location.state.status === 'MG') {
            this.getNewLoan(this.props.location.state.folio);
        }
    }

    getNewLoan(loanId) {
        this.loading(true);
        this.controlPanelService.getNewLoan(this.props.location.state.folio).then(
            response => {
                let newLoan = '[' +
                    '{"plazo":"' + response[2] + '",' +
                    '"tasa":"' + response[3] + '",' +
                    '"sobreTasa":"' + response[4] + '",' +
                    '"premio":"' + response[5] + '",' +
                    '"CantDisp":"' + response[6] + '"}' +
                    ']';

                let json = JSON.parse(newLoan);

                this.setState({
                    extensionData: {
                        plazo: json[0].plazo,
                        tasa: json[0].tasa * 100,
                        sobretasa: json[0].sobreTasa * 100,
                        disableValues: true,
                    },
                });
                this.loading(false);
                this.changeGuaranteeScreen();
            });


    }

    async componentDidMount() {
        await this.loanData.current.getLoan();
        await this.loanData.current.getRestrictionsLoan(this.state.loanId);
        await this.guaranteeInAccount.current.setLoanAmount(this.loanData.current.state.amount);
        await this.guaranteeForChange.current.setLoanAmount(this.loanData.current.state.amount);

        await this.updateGuaranteeGrids();
        await this.validateMarginCall();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.guaranteeInAccount.current.setState({
            guaranteeAmountInLoanTotal: this.guaranteeForChange.current.state.guaranteeAmountTotal,
            marketAmountInLoanTotal: this.guaranteeForChange.current.state.marketAmountTotal,
        });
    }

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message: message,
        });
    }

    validateDataExtension() {
        return this.state.extensionData.plazo === '' ||
            this.state.extensionData.tasa === '' ||
            this.state.extensionData.sobretasa === '';
    }

    showExtensionConfirmationMessage() {
        if (this.extensionConfirmationRef) {
            this.extensionConfirmationRef.openConfirmationMessage()
        }
    }

    showGuaranteeConfirmationMessage() {
        if (this.guaranteeConfirmationRef) {
            this.guaranteeConfirmationRef.openConfirmationMessage()
        }
    }

    validateExtensionPr() {
        this.loading(true);
        if (this.validateDataExtension()) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Favor de validar los datos a capturar'});
            this.loading(false);
        } else {
            this.moveGuaranteeService.validateExtensionPr(
                this.state.loanId,
                this.state.extensionData.plazo,
                this.state.status,
                this.state.extensionType
            ).then(response => {
                this.loading(false);
                if (response.error !== '') {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.setState({
                        extensionType: response.payload[0],
                    });

                    if (response.payload[0] !== "N" && !this.state.isVisibleGuarantee) {
                        if (response.payload[0] === "S"){
                            this.setState({
                                legendGuaranteesConfirmMsg: "Una o más emisoras vencen en el nuevo plazo. ¿Desea continuar?"
                            });
                        }else{//
                            this.setState({
                                legendGuaranteesConfirmMsg: "¿Está seguro que desea prorrogar el préstamo?"
                            });
                        }
                        this.showGuaranteeConfirmationMessage();
                    } else {
                        this.showExtensionConfirmationMessage();
                    }
                }
            });
        }
    }

    showGuarantees() {
        this.changeGuaranteeScreen();
        this.guaranteeInAccount.current.getGuaranteeInAccount(this.guaranteeInAccount.current.state.account);
    }

    updateGuaranteeTotal(guaranteeAmountTotal, marketAmountTotal) {
        this.setState({
            guaranteeAmount: guaranteeAmountTotal,
            marketAmount: marketAmountTotal,
        });

        this.guaranteeInAccount.current.updateInLoanTotals(guaranteeAmountTotal, marketAmountTotal);
    }

    extendLoan() {
        if (
            this.state.extensionType !== 'N' &&
            this.loanData.current.state.amount >
            amountCalculate(this.guaranteeInAccount.current.state.guaranteeAmountTotal)) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar las garantías"});
        } else {
            let arrayGuarantee = [];

            this.guaranteeForChange.current.state.guaranteeList.map(
                (item) => {
                    if (item.newTitles && item.newTitles > 0) {
                        arrayGuarantee.push({
                            idEmisora: item.idEmisora,
                            titulos: item.newTitles,
                            idOperacion: 2
                        });
                    }
                    return '';
                });

            this.guaranteeInAccount.current.state.guaranteeList.map(
                (item) => {
                    if (item.newTitles && item.newTitles > 0) {
                        arrayGuarantee.push({
                            idEmisora: item.idEmisora,
                            titulos: item.newTitles,
                            idOperacion: 3
                        });
                    }
                    return '';
                });

            this.loading(true);
            this.moveGuaranteeService.extensionPr(
                this.state.loanId,
                this.state.status,
                this.state.extensionData.plazo,
                this.state.extensionData.tasa,
                this.state.extensionData.sobretasa,
                arrayGuarantee
            ).then(resp => {
                if (resp.message === '') {
                    let message = {
                        severity: 'success',
                        summary: 'Éxito',
                        detail: 'La solicitud de prórroga se ha enviado exitosamente.',
                    };
                    this.handleReturnButton(message);
                } else if (resp.error && resp.error !== '') {
                    this.growl.show({
                        severity: 'error', summary: 'Error.',
                        detail: resp.error
                    });
                }
                this.loading(false);
            });
        }
    }

    validateMarginCall() {
        if (this.loanData.current.state.porcGarantizadoVal < this.loanData.current.state.porcRequeridoVal) {
            this.setState({
                extensionType: 'Ll',
            })
        }
    }

    changeGuaranteeScreen() {
        if (this.validateDataExtension()) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: 'Favor de validar los datos a capturar'});
        } else {
            this.moveGuaranteeService.validateExtensionPr(
                this.state.loanId,
                this.state.extensionData.plazo,
                this.state.status,
                this.state.extensionType
            ).then(response => {
                if (response.error !== '') {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.setState({
                        extensionType: 'S',//response,
                        disableValues: true,
                        isVisibleGuarantee: true,
                    });

                    this.updateGuaranteeGrids();

                    this.guaranteeForChange.current.enableSuggest();
                    this.guaranteeInAccount.current.show();
                }
            });
        }
    }

    async updateGuaranteeGrids() {
        await this.guaranteeInAccount.current.setMaturity(this.state.extensionData.plazo);
        await this.guaranteeForChange.current.setMaturity(this.state.extensionData.plazo);
        await this.guaranteeForChange.current.getGuarantee();
        await this.guaranteeInAccount.current.getGuaranteeInAccount(this.guaranteeInAccount.current.state.account);
    }

    saveData(event) {
        let {name, value, id} = event.target;
        value = value ? value : '';
        let extensionDataAux = this.state.extensionData;
        extensionDataAux[name] = value;
        let numValue = Number(withoutComma(value));

        if (name === "tasa" || name === "sobretasa") {
            extensionDataAux[name] = validateNumberIntegersDecimals(numValue, id, 2);
        }

        if (
            extensionDataAux["plazo"] > 0
            && extensionDataAux["tasa"] > 0
        ) {
            this.loanData.current.setReward(
                getReward(
                    this.loanData.current.state.titles,
                    this.loanData.current.state.price,
                    withoutComma(extensionDataAux["tasa"]),
                    withoutComma(extensionDataAux["plazo"])
                ));
        }


        this.setState({extensionData: extensionDataAux,})
    }

    redirectAddInstrument() {
        this.props.history.push({
            pathname: ADD_INSTRUMENT_ROUTE,
            state: {
                returnPath: CONTROL_PANEL_EXTENSION_LOAN,
                callScreen: "controlPanel",
                addGuarantee: true,
                loanId: this.state.loanId,
                account: this.state.account,
                loanAmount: this.loanData.current.state.amount,
                guaranteeAmount: this.guaranteeInAccount.current.state.guaranteeAmountTotal,
                selectedLoan: this.state.selectedLoan,
                maturity: this.state.maturity,
                status: this.state.status,
            },
        });
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        this.extensionConfMsg = <ConfirmationMessage ref={this.setExtensionConfirmationRef}
                                                     invisible={true}
                                                     legend="¿Está seguro que desea prorrogar el préstamo?"
                                                     action={this.extendLoan}/>;
        this.guaranteeConfMsg = <ConfirmationMessage ref={this.setGuaranteeConfirmationRef}
                                                     invisible={true}
                                                     legend={this.state.legendGuaranteesConfirmMsg}
                                                     action={this.showGuarantees}/>;

        return <ExtensionLoan
            isLoading={this.state.isLoading}
            extensionData={this.state.extensionData}
            loading={this.loading}
            messagesGrowl={messagesGrowl}
            extensionConfMsg={this.extensionConfMsg}
            guaranteeConfMsg={this.guaranteeConfMsg}
            handleReturnButton={this.handleReturnButton}
            changeGuaranteeScreen={this.changeGuaranteeScreen}
            selectedLoan={this.state.selectedLoan}
            loanId={this.state.loanId}
            loanAmount={this.state.loanAmount}
            account={this.state.account}
            extensionType={this.state.extensionType}
            saveData={this.saveData}
            disableValues={this.state.disableValues}
            validateExtensionPr={this.validateExtensionPr}
            loanData={this.loanData}
            guaranteeAmount={this.state.guaranteeAmount}
            guaranteeInAccount={this.guaranteeInAccount}
            guaranteeForChange={this.guaranteeForChange}
            updateGuaranteeTotal={this.updateGuaranteeTotal}
            redirectAddInstrument={this.redirectAddInstrument}
        />

    }
};